import ability from '@/common/ability';
import { NavigationGuard } from 'vue-router';
import usePermissionsStore from '@/common/store/pinia/permissions';
import { storeToRefs } from 'pinia';
import { watch, WatchStopHandle } from 'vue';
import useAuthStore from '@/common/store/pinia/auth';

export function checkPermissions(to) {
  return !to.meta?.restrictions?.resource
    || (ability.can(to.meta.restrictions.action || 'read', to.meta.restrictions.resource));
}

export default (function (to, from, next) {
    // NOTE (alkurbatov): Empty route.path stands to the'/' route.
    // In this case we should check permissions and if a user is authenticated
    // he will be redirected to proper page by the navigation guard in the '/' route.
  if (to.matched.some(route => route.path && route.meta.public)) {
    next();
    return;
  }
  const authStore = useAuthStore();
  if (!authStore.currentUser) {
    next({
      name: 'Login',
      query: {
        redirectUrl: to.fullPath
      }
    });
    return;
  }

  let unwatch: WatchStopHandle;
  const permissionsLoadedHandler = () => {
    unwatch?.();
    if (checkPermissions(to)) {
      next();
    } else {
      next({ name: 'error403' });
    }
  };

  const permissionsStore = usePermissionsStore();
  if (permissionsStore.permissionsAreLoaded) {
    permissionsLoadedHandler();
    return;
  }

  unwatch = watch(storeToRefs(permissionsStore).permissionsAreLoaded, permissionsLoadedHandler);
}) as NavigationGuard;
